"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixColors = fixColors;
const tex_syntax_1 = require("./tex-syntax");
function fixColors(tex) {
    return (tex
        // A color then another color cancels out in KaTeX so we're doing that too
        .replace(new RegExp(`\\\\${tex_syntax_1.color}\\s*\\\\${tex_syntax_1.color}`, "g"), "")
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})(\\s*\\\\dfrac${(0, tex_syntax_1.arg)(4)}${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}")
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})(\\s*\\\\text${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}")
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})(\\s*\\\\operatorname${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}")
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})(\\s*\\\\mathbin${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}")
        // Fixes up color color color by making it behave like color color
        // when then gets fixed by the next regex
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})\\\\${tex_syntax_1.color}(\\s*\\\\${tex_syntax_1.color}${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}")
        .replace(new RegExp(`\\\\(${tex_syntax_1.color})(\\s*\\\\${tex_syntax_1.color}${(0, tex_syntax_1.arg)(4)})`, "g"), "\\$1{$2}"));
}
